<template>
  <WdsStack direction-column class="tw-px-2">
    <slot name="action">
      <WdsStack justify-space-between>
        <WdsText>
          {{ isWorker ? $t('Ready to start') : $t('Hire is ready') }}
        </WdsText>
        <WdsText>
          <div v-if="!loading && hire" class="tw-font-normal">
            {{ $t('Starting on :date', { date: startDate }) }}
          </div>
        </WdsText>
      </WdsStack>
      <WdsText secondary>
        <div class="tw-font-normal">
          {{
            isWorker
              ? $t("All required information has been provided and you're ready to start.")
              : hasRecruiterManagingWorkers
                ? $t('All required information has been provided and the hire is ready to start.')
                : $t('All required information has been provided and the worker is ready to start.')
          }}
        </div>
      </WdsText>
    </slot>
  </WdsStack>
  <HireComplianceGateStatus :compliances="active" :loading="complianceLoading" :hire-id="hireId" />
</template>

<script lang="ts" setup>
import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'
import { WdsStack, WdsText } from '@worksome/wds-components'
import { useHireRecruiter } from '../composables/useHireRecruiter'
import { graphql } from '@/gql'
import { ComplianceName } from '@/gql/graphql'
import HireComplianceGateStatus from '@/components/Hire/HirePageCompliance/HireComplianceGateStatus.vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import useDate from '@/composables/useDate'
import { useComplianceGate } from '@/components/Hire/HirePageCompliance/useComplianceGates'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'

const props = defineProps<{
  hireId: string
}>()

const { isWorker } = useAccountCapabilities()
const { hasRecruiterManagingWorkers } = useHireRecruiter(props.hireId)

const { result, loading } = useQuery(
  graphql(`
    query HireSignedStatus($id: ID!) {
      hire(id: $id) {
        id
        startDate
      }
    }
  `),
  {
    id: props.hireId,
  },
  {
    clientId: 'publicApi',
  },
)

const hire = computed(() => result.value?.hire)

const startDate = computed(() => {
  if (!hire.value?.startDate) return ''
  return useDate(hire.value.startDate, 'MMM DD, YYYY').date.value
})

const { active, loading: complianceLoading } = useComplianceGate(
  props.hireId,
  ComplianceName.GateHireCreateBill,
)
</script>
